<template>
  <v-input hide-details>
    <v-menu
      content-class="w-time-picker__menu"
      offset-y
      max-height="60vh"
    >
      <template #activator="{ on }">
        <w-btn
          :disabled="disabled"
          v-on="on"
        >
          <span>{{ internalValue ? hour : 'H' }}</span>
          <w-icon
            color="white"
            right
          >
            mdi-menu-down
          </w-icon>
        </w-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="hr in 24"
          :key="hr"
          class="pr-0 pl-2"
          @click="hour = hr === 24 ? 0 : hr"
        >
          {{ `${hr === 24 ? 0 : hr}`.padStart(2, '0') }}
        </v-list-item>
      </v-list>
    </v-menu>
    <div class="px-2">
      :
    </div>
    <v-menu
      v-model="minMenu"
      offset-y
      max-height="60vh"
      :close-on-content-click="false"
      content-class="w-time-picker__menu"
    >
      <template #activator="{ on: menu }">
        <w-btn
          :disabled="disabled"
          v-on="menu"
        >
          <span>{{ internalValue ? minute : 'M' }}</span>
          <w-icon
            color="white"
            right
          >
            mdi-menu-down
          </w-icon>
        </w-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="min in minuteList"
          :key="min"
          class="pr-0 pl-2"
          :class="getMinuteClass(min)"
          @click="onMinuteClick(min)"
        >
          <v-icon v-if="min.includes('-')">
            mdi-dots-horizontal
          </v-icon>
          <span v-else>{{ min }}</span>
        </v-list-item>
      </v-list>
    </v-menu>
    <div class="pl-2 pr-2">
      {{ $t('Common.clock') }}
    </div>
  </v-input>
</template>

<script>
import i18n from '@/language/i18n';

export default {
  name: 'WorkTimePicker',
  props: {
    alwaysShow: {
      type: Array,
      default: () => [0, 15, 30, 45],
    },
    label: {
      type: String,
      default: i18n.t('Common.time'),
    },
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedMinutes: null,
      minMenu: false,
      internalValue: null,
    };
  },
  computed: {
    hour24() {
      if (!this.internalValue) return '00';
      return this.internalValue.split(':')[0];
    },
    hour: {
      get() {
        return this.hour24;
      },
      set(value) {
        if (value) {
          const hr = `${value}`.padStart(2, '0');
          this.internalValue = `${hr}:${this.minute}`;
          this.$emit('input', this.internalValue);
        }
      },
    },
    expandedStart() {
      return this.expandedMinutes
        ? parseInt(this.expandedMinutes.split('-')[1])
        : -1;
    },
    expandedEnd() {
      return this.expandedMinutes
        ? parseInt(this.expandedMinutes.split('-')[2])
        : -1;
    },
    minuteList() {
      return Array.from(Array(60).keys())
        .map((i) => {
          if (
            this.alwaysShow.includes(i) ||
            (i >= this.expandedStart && i <= this.expandedEnd)
          ) {
            return `${i}`.padStart(2, '0');
          } else if (this.alwaysShow.includes(i - 1)) {
            const end = this.alwaysShow.find((a) => a > i) || 59;
            return `ellipsis-${i}-${end}`;
          } else {
            return false;
          }
        })
        .filter((i) => !!i);
    },
    minute: {
      get() {
        if (!this.internalValue) return '00';
        return this.internalValue.split(':')[1].replace(/\D+/g, '');
      },
      set(value) {
        if (value) {
          this.internalValue = `${this.hour24.padStart(2, '0')}:${value}`;
          this.$emit('input', this.internalValue);
        }
      },
    },
  },
  mounted() {
    this.internalValue = this.value;
  },
  methods: {
    onMinuteClick(min) {
      const isEllipsis = min.includes('-');
      this.expandedMinutes = isEllipsis ? min : null;
      if (!isEllipsis) {
        this.minMenu = false;
        this.minute = min;
      }
    },
    getMinuteClass(min) {
      return this.alwaysShow.includes(parseInt(min)) ? 'font-weight-bold' : '';
    },
  },
  watch: {
    value(value) {
      this.internalValue = value;
    },
  },
};
</script>
<style lang="scss" scoped>
.w-time-picker__menu {
  @include header-menu;
  background-color: $cards-bg-color !important;
  .v-list {
    background-color: $cards-bg-color !important
  }
}
</style>